import { stateDistricts } from "../../data/stateDistricts";
import { CourtLocationErrors, CourtLocationForm, defaultCourtLocation, defaultReturnAddress, defaultSignature, ReturnAddressForm, SignatureForm } from "../../utils/constant";

interface CourtLocationType {
  formData: CourtLocationForm;
  formDataErrors: CourtLocationErrors;
  requestError: string;
  requestSuccess: string;
  states: string[];
}

export const courtLocationInitialState: CourtLocationType = {
  formData: defaultCourtLocation,
  formDataErrors: {
    stateError: '',
    districtError: '',
    divisionError: '',
  },
  requestError: '',
  requestSuccess: '',
  states: Object.keys(stateDistricts),
};

interface ReturnAddressErrors {
  returnAddressNameError: string;
  firmNameError: string;
  address1Error: string;
  address2Error: string;
  cityError: string;
  stateError: string;
  zipError: string;
}

interface ReturnAddressType {
  formData: ReturnAddressForm;
  formDataErrors: ReturnAddressErrors;
  requestError: string;
  requestSuccess: string;
  isFetchingAddresses: boolean;
  isSettingDefaultAddress: boolean;
}

export const returnAddressInitialState: ReturnAddressType = {
  formData: defaultReturnAddress,
  isFetchingAddresses: false,
  isSettingDefaultAddress: false,
  formDataErrors: {
    returnAddressNameError: '',
    firmNameError: '',
    address1Error: '',
    address2Error: '',
    cityError: '',
    stateError: '',
    zipError: '',
  },
  requestError: '',
  requestSuccess: '',
};

interface SignatureErrors {
  fullNameError: string;
  barNumberError: string;
  firmNameSignatureError: string;
  address1SignatureError: string;
  address2SignatureError: string;
  citySignatureError: string;
  stateSignatureError: string;
  zipSignatureError: string;
  phoneError: string;
  emailError: string;
  faxError: string;
  countryError: string;
  clientRoleError: string;
}

interface SignatureType {
  formData: SignatureForm;
  formDataErrors: SignatureErrors;
  requestError: string;
  requestSuccess: string;
  isSettingDefault: boolean;
  isFetchingSignatures: boolean;
}

export const signatureInitialState: SignatureType = {
  formData: defaultSignature,
  isSettingDefault: false,
  isFetchingSignatures: false,
  formDataErrors: {
    fullNameError: '',
    barNumberError: '',
    firmNameSignatureError: '',
    address1SignatureError: '',
    address2SignatureError: '',
    citySignatureError: '',
    stateSignatureError: '',
    zipSignatureError: '',
    phoneError: '',
    emailError: '',
    faxError: '',
    countryError: '',
    clientRoleError: '',
  },
  requestError: '',
  requestSuccess: '',
};